import React, { Component } from 'react'
import { getCookie, setCookie } from './utils/cookies'
import generateRandomNickname from './utils/nickname'
import overrideGeo from './apis/geoOverride'
import queryParams from './utils/queryParams'

import Client from './irc/Client'
import Config from './config/config'
import getHistory from './apis/history'

import Login from './views/login/Login'
import BaseChat from './views/chat/BaseChat'
import Connecting from './views/connecting/Connecting'
import Welcome from './views/welcome/Welcome'

import { Button, Icon, Modal } from 'semantic-ui-react'

import 'semantic-ui-css/semantic.min.css'

class App extends Component {
  constructor() {
    super()

    this.hideActivityIndicator()

    this.savedNickname = getCookie('NICKNAME')
    this.notificationAudio = new Audio('/sounds/notification.mp3')

    this.state = {
      loggedIn: false,
      nickname: this.savedNickname || generateRandomNickname(),
      connecting: false,
      connected: false,
      awayTimer: null,
      error: null,
      backgrounded: false,
      welcomeModalOpen: getCookie('DID_VIEW_WELCOME_SCREEN') !== 'true',
    }

    this.handleLogin = this.handleLogin.bind(this)
    this.welcomeModalClosed = this.welcomeModalClosed.bind(this)

    window.addEventListener('offline', this.onOffline.bind(this))
    window.addEventListener('online', this.onOnline.bind(this))

    window.addEventListener(
      'SELFDIDJOIN',
      function(command) {
        this.setState({ connecting: false, loggedIn: true })
        if (window.analytics) {
          const now = Math.round(new Date().getTime() / 1000)
          const duration = now - window.connectionStart

          window.analytics.track('IRC Connection Complete', {
            duration: duration,
          })
        }

        if (this.state.backgrounded) {
          this.showActivityIndicator()
        }
      }.bind(this),
    )

    window.addEventListener(
      'PRIVMSG',
      function(command) {
        if (this.state.backgrounded) {
          this.showActivityIndicator()
        }
      }.bind(this),
    )

    window.addEventListener(
      'KICK',
      function(command) {
        const kick = command.detail
        if (kick.args[1] === this.client.nickname) {
          this.didDisconnect(`You have been removed from #TheCabin. ${kick.args[2]}`)
        }
      }.bind(this),
    )

    window.addEventListener(
      'err_nicknameinuse',
      function(command) {
        this.didDisconnect(`${this.client.nickname} is a nickname already in use. Please select a new one`)
      }.bind(this),
    )

    window.addEventListener(
      'err_bannedfromchan',
      function(command) {
        this.didDisconnect('You have been banned from #TheCabin')
      }.bind(this),
    )

    window.addEventListener(
      'SELFDIDDISCONNECT',
      function(command) {
        this.didDisconnect('You have been disconnected.  Please try again')
      }.bind(this),
    )

    window.addEventListener(
      'ERROR',
      function(command) {
        const error = command.detail
        this.didDisconnect(`You have been disconnected:  ${error}`)
      }.bind(this),
    )

    window.addEventListener(
      'SELFDIDCONNECT',
      function(command) {
        this.setState({ connected: true })
      }.bind(this),
    )
  }

  componentDidMount() {
    // Auto Login
    if (queryParams(window.location.href).nickname) {
      this.handleLogin(queryParams(window.location.href).nickname)
    } else if (this.savedNickname) {
      this.handleLogin(this.state.nickname)
    }
    this.listenForVisibilityChange()
  }

  listenForVisibilityChange() {
    let visibilityChange
    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      visibilityChange = 'visibilitychange'
    } else if (typeof document.msHidden !== 'undefined') {
      visibilityChange = 'msvisibilitychange'
    } else if (typeof document.webkitHidden !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange'
    }
    document.addEventListener(visibilityChange, this.handleVisibilityChange.bind(this), false)
  }

  handleVisibilityChange() {
    let hidden
    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden'
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden'
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden'
    }

    clearTimeout(this.awayTimer)
    if (document[hidden]) {
      this.didEnterBackground()
    } else {
      this.didEnterForeground()
    }
  }

  didDisconnect(reason) {
    if (this.state.backgrounded) {
      this.showActivityIndicator()
    }

    if (reason && !this.state.error) {
      alert(reason)
    }

    this.setState({
      error: this.state.error || reason,
      loggedIn: false,
      connecting: false,
      connected: false,
    })
    this.client.quit()
  }

  render() {
    return (
      <div>
        {this.loginView()}
        {this.chatView()}
        {this.connectingView()}
        {this.welcomeView()}
      </div>
    )
  }

  handleLogin(nickname) {
    window.connectionStart = Math.round(new Date().getTime() / 1000)

    this.setState({
      nickname: nickname,
      connecting: true,
      error: null,
    })
    this.client = new Client(Config.channel, nickname)

    if (window.analytics) {
      window.analytics.identify(nickname, {
        nickname: nickname,
      })
      window.analytics.track('IRC Connection Start')
    }

    this.populateHistory()
    overrideGeo()
  }

  async populateHistory() {
    try {
      const history = await getHistory()
      this.setState({ history: history })
    } catch (error) {
      console.log(error)
    }

    setTimeout(
      function() {
        this.setState({ loggedIn: true })
      }.bind(this),
      7000,
    )
  }

  connectingView() {
    if (this.state.connecting && !this.state.loggedIn) {
      return (
        <div style={{ opacity: 0.85 }}>
          <Connecting />
        </div>
      )
    }
  }

  chatView() {
    if (this.state.connecting || this.state.loggedIn) {
      return (
        <div>
          <BaseChat client={this.client} history={this.state.history} connecting={this.state.connecting} loggedIn={this.state.loggedIn} />
        </div>
      )
    }
  }

  loginView() {
    if (!this.state.connecting && !this.state.loggedIn) {
      return <Login error={this.state.error} handleLogin={this.handleLogin} />
    }
  }

  welcomeView() {
    return (
      <Modal
        closeOnDimmerClick={true}
        closeOnDocumentClick={true}
        style={{ zIndex: 1000 }}
        dimmer="blurring"
        closeIcon
        open={this.state.loggedIn && this.state.welcomeModalOpen}
        onClose={this.welcomeModalClosed}
        size="small"
      >
        <Modal.Content>
          <Welcome />
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={this.welcomeModalClosed} inverted>
            <Icon name="checkmark" /> Let's Chat!
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  welcomeModalClosed() {
    this.setState({
      welcomeModalOpen: false,
    })
    setCookie('DID_VIEW_WELCOME_SCREEN', true)
  }

  didEnterBackground() {
    this.setState({
      backgrounded: true,
    })

    this.awayTimer = setTimeout(
      function() {
        if (this.client) {
          this.client.sendData('AWAY Backgrounded')
        }
      }.bind(this),
      Config.autoAwayDuration,
    )
  }

  didEnterForeground() {
    if (this.client) {
      this.client.sendData('AWAY')
    }
    this.hideActivityIndicator()
    this.setState({
      backgrounded: false,
    })
  }

  showActivityIndicator() {
    document.title = `💬🗨💬 ${Config.title}`
    const playAudio = getCookie('NOTIFICATION_SOUNDS_DISABLED') === 'true'
    if (!playAudio) {
      try {
        this.notificationAudio.play()
      } catch (exception) {}
    }
  }

  hideActivityIndicator() {
    document.title = Config.title
  }

  onOnline() {}

  onOffline() {
    this.offlineDoubleCheckTimer = setTimeout(
      function() {
        if (!navigator.onLine) {
          this.didDisconnect('You have lost your internet connection')
        }
      }.bind(this),
      3000,
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js